<script></script>
<section class="section-my-reservation">
  <div class="container-my-reservation">
    <div class="header-my-reservation">
      <div class="icon-my-reservation">
        <i class="bi bi-calendar-day"></i>
      </div>
      <div class="text-my-reservation">
        <h3>{{ "MyReservation" | translate }}</h3>
      </div>
    </div>
    <div class="content-my-reservation">
      <div class="item-my-reservation">
        <h4>{{"TypeOfService" |translate}}</h4>
        <p>{{ tip_service.serviceName ? (tip_service.serviceName | translate) : "-" }}</p>
        <!-- <div *ngfor="let reserv of Object.keys(dato)">
                    <p>{{reserv}}</p>
                </div> -->
      </div>

      <div class="item-my-reservation">
        <h4>{{"Mileage" |translate}}</h4>
        <p>{{ kilometraje ? kilometraje : "-" }}</p>
      </div>

      <div class="item-my-reservation">
        <h4>{{"City" |translate}}</h4>
        <p>{{ cityName }}</p>
      </div>

      <div class="item-my-reservation">
        <h4>{{"Workshop" |translate}}</h4>
        <p>{{ taller ? taller : "-" }}</p>
      </div>

      <div class="item-my-reservation">
        <h4>{{"Advisor" |translate}}</h4>
        <p>{{ asesor ? asesor : "-" }}</p>
      </div>

      <div class="item-my-reservation">
        <h4>{{"Date" |translate}}</h4>
        <p>{{ date === "Invalid date" || !date ? "-" : date }}</p>
      </div>

      <div class="item-my-reservation">
        <h4>{{"Hours" |translate}}</h4>
        <p>{{ time ? time : "-" }}</p>
      </div>
    </div>
  </div>
</section>
